module.exports = __webpack_public_path__ + "img/racing-de-santander-logo-icon.b9078133.webp";